import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  ADMIN_CSV_READY,
  ADMIN_CSV_READY_WINDOW_EVENT,
  REPORT_TYPE_LABELS,
  createAdminCsvSocket,
  getReportDownloadUrl,
  getReportTypeFromPayload,
} from "../utils/adminCsvSocket";

/**
 * Keeps a global socket connection while admin is logged in,
 * so export toasts work even when user leaves Sales & Performance.
 */
function AdminCsvSocketListener() {
  const location = useLocation();
  const [token, setToken] = useState(() => localStorage.getItem("sessionToken"));

  useEffect(() => {
    setToken(localStorage.getItem("sessionToken"));
  }, [location.pathname]);

  useEffect(() => {
    if (!token) return undefined;

    const socket = createAdminCsvSocket();

    const handleCsvReady = (payload = {}) => {
      console.log(`[AdminCsvSocket] Event received ← ${ADMIN_CSV_READY}`, payload);

      const reportType = getReportTypeFromPayload(payload);
      const label = REPORT_TYPE_LABELS[reportType] || "Report";
      const downloadUrl = getReportDownloadUrl(payload);
      const message =
        payload?.message ||
        payload?.data?.message ||
        `${label} is ready for download.`;

      toast.success(
        <div>
          <div>{message}</div>
          {downloadUrl ? (
            <a
              href={downloadUrl}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              Download now
            </a>
          ) : null}
        </div>,
        { autoClose: 8000 }
      );

      window.dispatchEvent(
        new CustomEvent(ADMIN_CSV_READY_WINDOW_EVENT, {
          detail: payload,
        })
      );
    };

    socket.on(ADMIN_CSV_READY, handleCsvReady);

    return () => {
      socket.off(ADMIN_CSV_READY, handleCsvReady);
      socket.disconnect();
    };
  }, [token]);

  return null;
}

export default AdminCsvSocketListener;
